import { Component, OnInit } from '@angular/core';
import { RestService } from '../../services/rest/rest.service';
import { StorageService } from 'src/app/services/storage/storage.service';

interface FailedEmail {
  to: string;
  reason: string;
  event: string;
}

@Component({
  selector: 'app-failed-emails',
  templateUrl: './failed-emails.component.html',
  styleUrls: ['./failed-emails.component.scss'],
})
export class FailedEmailsComponent implements OnInit {
  domains: string[] = ['machucainvest.es', 'cumbreno.es', 'artehielo.es'];
  failedEmails: { [domain: string]: FailedEmail[] } = {};
  paging: any = {};
  userRole: any;
  currentPage = 0;
  maxPage = 0;
  limit = 50;
  empty: boolean = false;

  columns = [
    { field: 'to', name: 'Email', width: 30 },
    { field: 'reason', name: 'Reason', width: 50 },
    { field: 'event', name: 'Event', width: 20 }
  ];

  constructor(private restService: RestService, private storageService: StorageService) {}

  ngOnInit(): void {
    this.loadAllFailedEmails();
  }

  loadAllFailedEmails(): void {
    this.domains.forEach(domain => {
      this.loadFailedEmails(domain);
    });
  }

  loadFailedEmails(domain: string): void {
    this.restService.getFailedEmails(domain).subscribe(
      (data) => {
        if (data.items.length === 0) {
          this.empty = true;
        } else {
            this.failedEmails[domain] = data.items.map(item => ({
              to: item.message.headers.to,
              event: item.event
            }));
            this.paging = data.paging;
        }
      },
      (error) => {
        console.error('Error fetching failed emails:', error);
      }
    );
  }

  mockFailedEmails(): void {
    this.failedEmails = {
      'machucainvest.es': [
        {
          to: 'joan@example.org',
          reason: 'Sandbox subdomains are for test purposes only. Please add your own domain or add the address to authorized recipients in Account Settings.',
          event: "failed"
        },
        {
          to: 'alice@example.com',
          reason: 'Recipient email server rejected the message.',
          event: "failed"
        },
        {
          to: 'bob@example.net',
          reason: 'Invalid email address format.',
          event: "failed"
        }
      ],
      'cumbreno.es': [
        {
          to: 'carlos@example.com',
          reason: 'Recipient email server is not responding.',
          event: "failed"
        }
      ],
      'artehielo.es': [
        {
          to: 'maria@example.com',
          reason: 'Email address does not exist.',
          event: "failed"
        }
      ]
    };
    this.paging = {
      next: null,
      previous: null
    };
  }
}
